import cx from 'classnames'
import React, { useEffect } from 'react'

import CTA from '@f/elements/CTA'

const LocationError = props => {
  useEffect(() => {
    props.actions.errorProgressBar()
    props.actions.update_wtValue({ value: 'error-location-outside-germany' })
  }, [])

  const isConversionFunnel = Boolean(props.funnelVariant)

  return (
    <div
      className={cx(
        'RequestWizard-form-wrapper',
        isConversionFunnel &&
          'RequestWizard-form-wrapper--HDP_conversion-funnel f-p-b-040'
      )}>
      <div className='RequestWizard-top'>
        <div className='RequestWizard-heading'>
          <div className='[ f-t-tmedium f-c-fo-pri f-t-centre f-p-h-080:m ]'>
            Ihre Anfrage konnte nicht versandt werden.
          </div>
          <div className='[ f-t-body f-c-fo-pri f-t-centre f-m-t-005 f-p-h-080:m ]'>
            Wir bieten unseren Service bisher nur Kunden in Deutschland und
            Österreich an.
            <strong className='[ f-d-bl ]'>
              Sie bauen in Deutschland oder Österreich?
            </strong>
          </div>
        </div>

        <div className='RequestWizard-content'>
          <div className='[ f-t-centre ]'>
            <CTA
              type='block-primary'
              tag='button'
              className='[ f-m-h-auto is-failure ]'
              data-sel='change-location'
              onClick={props.actions.displayLocationChangeScreen}>
              Bauort ändern
            </CTA>
          </div>
        </div>
      </div>
    </div>
  )
}

export default LocationError
